"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { AllModels as SharedAllModels } from "@llmgateway/shared/components";
import type { ComponentProps } from "react";
type SharedAllModelsProps = ComponentProps<typeof SharedAllModels>;
export function DevPassModelsDirectory(t0) {
  const $ = _c(7);
  let rest;
  let uiUrl;
  if ($[0] !== t0) {
    ({
      uiUrl,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = uiUrl;
  } else {
    rest = $[1];
    uiUrl = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Footer />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== rest || $[5] !== uiUrl) {
    t2 = <SharedAllModels {...rest} modelHrefBase={uiUrl} showPricingTierFilter={true} defaultCategory="code" hideUseCaseFilter={true} footer={t1} renderCta={_temp} />;
    $[4] = rest;
    $[5] = uiUrl;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(t0) {
  const {
    size,
    className,
    iconClassName,
    onClick
  } = t0;
  return <Button variant="default" size={size} className={className} onClick={onClick} asChild={true}><Link href="/signup">Get DevPass<ArrowRight className={iconClassName} /></Link></Button>;
}